/**
 * Experiment setting for improvements to help center search and navigation
 */
export const HELP_CENTER_SEARCH_AND_NAV_IMPROVEMENTS_240715 = 'HELP_CENTER_SEARCH_AND_NAV_IMPROVEMENTS_240715';
